import Crud from '../views/Poi/Crud'
import Entity from '../views/Poi/Add'

let routes = {
    path: '/pois',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/pois/add',
            name: 'NewPoi',
            component: Entity,
            meta: {
                pageTitle: 'poi.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'poi.form.newTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/pois/edit/:id?',
            name: 'EditPoi',
            component: Entity,
            meta: {
                pageTitle: 'poi.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'poi.form.editTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/pois',
            name: 'list-pois',
            component: Crud,
            meta: {
                pageTitle: 'poi.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'poi.crud.title',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
